import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ListLoader } from '../../../shared/components/list-loader/list-loader';
import { LastRechtRootEntryVm, StandardrechtViewmodelService } from '../../../core/services/standardrecht-viewmodel.service';
import { ListLoaderInfiniteBuilder } from '../../../shared/components/list-loader/list-loader-infinite';
import { AppConfigService } from '../../../core/services/app-config.service';
import { TimepointService } from '../../../core/services/timepoint.service';
import { EigentumanteilMasterDetailVM, EigentumViewmodelService } from '../../../core/services/eigentum-viewmodel.service';
import { AbstractGrundstueckEntryFromRoute } from '../abstract-grundstueck-entry-from.route';
import { GbgrundstueckService } from '../../../core/gb-api';
import { AppPermissionService } from 'app/core/services/app-permission.service';
import { map, tap } from 'rxjs/operators';
import { FormatConfigService } from 'app/core/services/format-config.service';
import { ErweiterungConfigResponse } from 'app/core/base-api';
import { NavTarget } from '../../../shared/components/link/link.component';
import { RubrikComponent } from '../../../shared/components/rubrik/rubrik.component';
import { GrundstueckBeschreibungComponent } from '../../beschreibung/grundstueck-beschreibung.component';
import { StandardrechtTableComponent } from '../../../shared/widgets/standardrecht-table/standardrecht-table.component';
import { EigentumTableComponent } from '../../../shared/widgets/eigentum-table/eigentum-table.component';
import { NeskoabRubrikUebersichtComponent } from '../neskoab-rubrik/neskoab-rubrik-uebersicht/neskoab-rubrik-uebersicht.component';
import { OerebTableUebersichtComponent } from '../../../oereb/oereb-uebersicht/oereb-table-uebersicht.component';
import { TranslatePipe } from '@ngx-translate/core';
import ActiveErweiterungenEnum = ErweiterungConfigResponse.ActiveErweiterungenEnum;

@Component({
  selector: 'cap-grundstueck-uebersicht-rubrik',
  templateUrl: './grundstueck-uebersicht-rubrik.component.html',
  styleUrls: ['./grundstueck-uebersicht-rubrik.component.scss'],
  imports: [
    RubrikComponent,
    GrundstueckBeschreibungComponent,
    StandardrechtTableComponent,
    EigentumTableComponent,
    NeskoabRubrikUebersichtComponent,
    OerebTableUebersichtComponent,
    TranslatePipe
  ]
})
export class GrundstueckUebersichtRubrikComponent extends AbstractGrundstueckEntryFromRoute implements OnInit {
  eigentumLoader: ListLoader<EigentumanteilMasterDetailVM>;
  eigentumErsterfassungUebergeben: boolean;

  anmerkungListLoader: ListLoader<LastRechtRootEntryVm>;
  anmerkungErsterfassungUebergeben: boolean;

  showLableNichtOeffentlicheAnmerkungen: boolean;
  protected isErweiterungNeskoabAktiv: boolean = false;
  protected isErweiterungOerebAktiv: boolean = false;
  private readonly CHUNK_SIZE_ANMERKUNGEN = 5;
  private readonly CHUNK_SIZE_EIGENTUM = 5;
  private readonly PAGE_SIZE = 5;
  private readonly CURRENT_PAGE = 1;

  navTargetGrundstuecke = NavTarget.NAV_GRUNDSTUECK;

  constructor(
    private eigentumviewmodelService: EigentumViewmodelService,
    private standardrechtViewmodelService: StandardrechtViewmodelService,
    protected route: ActivatedRoute,
    protected grundstueckService: GbgrundstueckService,
    protected timepointService: TimepointService,
    protected appConfigService: AppConfigService,
    private appFormatConfigService: FormatConfigService,
    private permissionService: AppPermissionService,
    protected router: Router
  ) {
    super(route, grundstueckService, timepointService, appConfigService, router);
  }

  ngOnInit() {
    this.showLableNichtOeffentlicheAnmerkungen = !this.permissionService.hasPermission('ANZEIGE_NICHT_OEFFENTLICHE_ANMERKUNGEN');
    super.ngOnInit();
    this.addSub(
      this.appFormatConfigService.erweiterungsConfig$.subscribe((config) => {
        this.isErweiterungNeskoabAktiv = config?.activeErweiterungen.includes(ActiveErweiterungenEnum.NESKO_SCHNITTELLE);
        this.isErweiterungOerebAktiv = config?.activeErweiterungen.includes(ActiveErweiterungenEnum.OEREB_CH);
      })
    );
  }

  protected loadData() {
    this.anmerkungListLoader = this.createAnmerkungLoader();
    this.eigentumLoader = this.createEigentumLoader();
  }

  private createAnmerkungLoader(): ListLoader<LastRechtRootEntryVm> {
    const observable = (offset: number, limit: number) => {
      return this.standardrechtViewmodelService.loadSichtByGrundstueckId(this.gsId, 'ANMERKUNG', offset, limit, this.subscriptions).pipe(
        tap((res) => (this.anmerkungErsterfassungUebergeben = res.ersterfassungUebergeben)),
        map((res) => res.entries)
      );
    };
    const loader = ListLoaderInfiniteBuilder.builder<LastRechtRootEntryVm>()
      .setLookupItemFunc(observable)
      .setChunkSize(this.CHUNK_SIZE_ANMERKUNGEN)
      .setPageSize(this.PAGE_SIZE)
      .setCurrentPage(this.CURRENT_PAGE)
      .setPublishItemsWhenAllLoaded(true)
      .build();
    this.addLoader(loader);
    return loader;
  }

  private createEigentumLoader() {
    const observable = (offset, limit) => {
      return this.eigentumviewmodelService.loadSichtByGrundstueckId(this.gsId, false, true, true, offset, limit, this.subscriptions).pipe(
        tap((res) => (this.eigentumErsterfassungUebergeben = res.ersterfassungUebergeben)),
        map((res) => res.entries)
      );
    };

    const loader = ListLoaderInfiniteBuilder.builder<EigentumanteilMasterDetailVM>()
      .setLookupItemFunc(observable)
      .setCurrentPage(this.CURRENT_PAGE)
      .setPageSize(this.PAGE_SIZE)
      .setChunkSize(this.CHUNK_SIZE_EIGENTUM)
      .build();
    this.addLoader(loader);
    return loader;
  }
}
